import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const MinorContractsMain = lazy(
  () => import('../minor-contracts/MinorContractsMain')
);
const MNVerification = lazy(
  () => import('../minor-contracts/verification/MNVerification')
);

const AddendumCs = lazy(() => import('../minor-contracts/addc/AddendumCMain'));
const DraftContracts = lazy(
  () => import('../minor-contracts/DraftContracts/DraftContractsMain')
);

const AssignmentTracking = lazy(
  () => import('../minor-contracts/assignment/AssignmentTracking')
);

export default [
  {
    id: NavConfig.groupConfigs.MINOR_CONTRACTS.id,
    path: NavConfig.groupConfigs.MINOR_CONTRACTS.to,
    element: (
      <MinorContractsMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </MinorContractsMain>
    ),

    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.MN_VERIFICATION.to} />,
      },
      {
        id: NavConfig.linkConfigs.MN_VERIFICATION.id,
        path: NavConfig.linkConfigs.MN_VERIFICATION.to,
        element: <MNVerification />,
      },
      {
        id: NavConfig.linkConfigs.MN_ADDENDUM_C.id,
        path: NavConfig.linkConfigs.MN_ADDENDUM_C.to,
        element: <AddendumCs />,
      },
      {
        id: NavConfig.linkConfigs.MN_DRAFT_CONTRACTS.id,
        path: NavConfig.linkConfigs.MN_DRAFT_CONTRACTS.to,
        element: <DraftContracts />,
      },
      {
        id: NavConfig.linkConfigs.MN_ASSIGNMENT.id,
        path: NavConfig.linkConfigs.MN_ASSIGNMENT.to,
        element: <AssignmentTracking />,
      },
    ],
  },
];
